import React from "react";

type CardButtonProps = {
    children: React.ReactNode;
    onClick?: () => void;
    disabled?: boolean;
    className?: string;
};

const CardButton: React.FC<CardButtonProps> = ({ children, onClick, disabled = false, className = "" }) => {
    // Using a button for accessibility and native keyboard support
    return (
        <button
            type="button"
            className={`flex flex-col items-center justify-center gap-2 hover:cursor-pointer flex-1 py-3 border-1 rounded-lg border-gray-200 dark:border-neutral-700 transition-colors ${className}`}
            onClick={onClick}
            disabled={disabled}
        >
            {children}
        </button>
    );
};

export default CardButton;
